import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: '¿Sirve si recién empiezo a tejer amigurumis?',
  a: 'Es el sistema ideal para cualquier nivel. Si recién empezás, construís todo bien desde cero y evitás los errores caros que arruinan los primeros intentos. Si ya tejés hace tiempo, ordenás tu proceso, mejorás tus terminaciones y finalmente cobrás lo que tu trabajo realmente vale.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después de tu pago recibís un correo con el link de descarga directo. Todo en formato PDF, compatible con celular, tablet y computadora. Sin esperas, sin envíos físicos.'
}, {
  q: '¿Es realmente para el mercado argentino?',
  a: '100%. Todos los precios, plataformas de pago (Mercado Pago), plataformas de envío (Correo Argentino, Andreani) y estrategias de redes sociales están adaptadas a la realidad argentina de 2026, con inflación y todo.'
}, {
  q: '¿Necesito tener muchos seguidores en Instagram para que funcione?',
  a: 'No. El sistema incluye estrategias tanto para crecer orgánicamente desde cero como para usar Meta Ads con presupuesto mínimo. Hay tejedoras que consiguieron sus primeros pedidos reales con menos de 200 seguidores.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. Tenés 7 días corridos desde la compra para pedir el reembolso completo. Sin preguntas, sin formularios complicados. Solo mandás un mensaje a soporte y te devolvemos el 100%.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Preguntas frecuentes" className="bg-ink" data-id="element-51" data-mp="rzkx6t23bp1j">
      <div className="mx-auto max-w-3xl px-5 pt-9" data-id="element-52" data-mp="rx853n2mbyar">
        <h2 className="text-center font-display text-3xl font-black text-white sm:text-4xl" data-id="element-53" data-mp="wz7a11e0b39t">
          ❓ Lo que más nos preguntan
        </h2>
        <div className="mt-10 divide-y divide-white/10 overflow-hidden rounded-2xl border border-white/10 bg-ink-2" data-id="element-54" data-mp="j0qssgiipudf">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          const panelId = `faq-panel-${i}`;
          return <div key={f.q} data-id="element-55" data-mp="2kv51j1v2vjc0" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors hover:bg-white/[0.03] focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-bordo-light" data-id="element-56" data-mp="2ktty535jodlf">
                  <span className="text-sm font-bold text-white sm:text-base" data-id="element-57" data-mp="2ymjx08669czy">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-bordo-light" aria-hidden="true" data-id="element-58" data-mp="2ukyfuamlucjy" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plata" aria-hidden="true" data-id="element-59" data-mp="1n61z03mxf2b7" />}
                </button>
                <div id={panelId} className="grid transition-all duration-300 ease-in-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-60" data-mp="3uu6he84lqohw">
                  <div className="overflow-hidden" data-id="element-61" data-mp="7oynma3kqbg6">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-white/65" data-id="element-62" data-mp="7n46l6vfb3hd">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}